import React, {ReactNode} from 'react';

/**
 *
 * @param children
 * @constructor
 */

function ContainerLayout({ children }: { children: ReactNode }) {
    return (
        <section className={"2xl:container w-full md:scroll-mt-3 sm:px-0 md:px-2 2xl:px-0 overflow-hidden md:overflow-visible  max-w-8xl"}>
            {children}
        </section>
    );
}

export default ContainerLayout;